import { ArrowBackIcon } from '@chakra-ui/icons';
import { HStack, IconButton, Link, Text } from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useRouter } from 'next/router';
import { forwardRef } from 'react';
export const BackButton = forwardRef(({ theme = 'light', ...props }, ref) => {
  const { back } = useRouter();
  const { t } = useTranslator();
  const color = theme === 'dark' ? 'black' : 'white';
  return (
    <Link as={HStack} onClick={(e) => back?.()}>
      <IconButton
        minW={2}
        color={color}
        _hover={{ color, bg: 'transparent' }}
        _active={{ color, bg: 'transparent' }}
        variant="ghost"
        {...props}
      >
        <ArrowBackIcon size="xs" />
      </IconButton>
      <Text fontSize="lg" color={color} {...props}>
      {t('buttons.back') || 'Back'}
      </Text>
    </Link>
  );
});
